import React from "react";
import BackButton from "../../commanComponents/buttons/BackButton";
import svgData from "../../constants/utilities/svgData";
import ColorBtn from "../../commanComponents/buttons/ColorBtn";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./report.css";
import ColorStatus from "../../commanComponents/ColorStatus";
import { useQuery } from "react-query";
import toast from "react-hot-toast";
import { communication } from "../../constants/apis/communication";
import { dateFormat, formatDateTime } from "../../constants/helpers/helperFunctions";
import Loader from "../../commanComponents/Loader";

export default function ReportLogs() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const reportId = searchParams.get("reportId");

  const { data: activitySheetDetails, isFetching } = useQuery(["getActivityById", reportId], () => communication?.getActivityById(reportId), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data?.data?.status == "SUCCESS") {
      } else if (data?.data?.status == "JWT_INVALID") {
        toast.error(`Failed: ${data?.data?.message}`);
      }
    },
    onError: (error) => {
      toast.error(`Failed: ${error?.message}`);
    },
  });

  return (
    <div style={{ padding: "16px 24px" }}>
      {isFetching && <Loader />}

      <div className="cardWrapper comman-box-shadow">
        <h5 className="redColor">Logs</h5>

        <div className={"timeline"}>
          <div></div>
          <div className={"timelineItem"}>
            <div className={"timelineDot"}>
              <div></div>
            </div>
            <div className={"timelineContent"}>
              <h6 className="text-capitalize">
                {`Created by ${activitySheetDetails?.data?.result?.createdBy?.name}`} <span className={"roleBadge"}>{activitySheetDetails?.data?.result?.createdBy?.designation}</span>
              </h6>
              <p className={"date"}>{formatDateTime(activitySheetDetails?.data?.result?.createdAt)}</p>
            </div>
          </div>
          {activitySheetDetails?.data?.result?.logs?.map((item, index) => (
            <div className={"timelineItem"} key={index}>
              <div className={"timelineDot"}>
                <div></div>
              </div>
              <div className={"timelineContent"}>
                <h6 className="text-capitalize">
                  {item?.approvedBy?.name
                    ? `Approved By ${item?.approvedBy?.name}`
                    : item?.reAssignedBy?.name
                      ? `Reassigned By ${item?.reAssignedBy?.name}`
                      : `Report updated by ${item?.updatedBy?.name}`}{" "}
                  <span className={"roleBadge text-capitalize"}>
                    {item?.approvedBy?.designation ? item?.approvedBy?.designation : item?.reAssignedBy?.designation ? item?.reAssignedBy?.designation : item?.updatedBy?.designation}
                  </span>
                </h6>
                <ColorStatus
                  text={item?.approvedBy?.name ? " Approved" : item?.reAssignedBy?.name ? "Reassigned" : "Updated"}
                  style={{
                    fontSize: "14px",
                    margin: "10px 0px",
                    backgroundColor: item?.approvedBy?.name ? "#a0e6a0" : item?.reAssignedBy?.name ? "rgb(242, 162, 174)" : "rgb(162, 213, 242)",
                    color: "black",
                  }}
                />
                <p className={"date"}>{formatDateTime(item.date)}</p>
                {item?.reAssignedBy?.name && <p className={"reason"}>{item?.reassignReason}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="submitBtnWrapper">
        <ColorBtn text={"Cancel"} color={"rgba(96, 91, 255, 1)"} onClick={() => navigate(-1)} />
      </div>
    </div>
  );
}
